/**
 * 认证相关工具函数
 */

// Token过期处理函数
export const handleTokenExpired = () => {
  console.log('Token expired, cleaning up and redirecting to login...')
  
  // 清除所有本地存储的认证信息
  localStorage.removeItem('userInfo')
  localStorage.removeItem('userToken')
  sessionStorage.clear() // 清除会话存储
  
  // 显示用户友好的提示消息
  alert('🔐 Your session has expired. Please login again.')
  
  // 跳转到登录页
  window.location.href = '/login'
}

// 检查是否是token过期相关的错误
export const isTokenExpiredError = (error, responseData = null) => {
  // 检查HTTP状态码
  if (error.status === 401 || error.status === 403 || error.status === 500) {
    // 对于500错误，需要进一步检查错误消息
    if (error.status === 500) {
      const errorMessage = error.message?.toLowerCase() || ''
      const responseMessage = responseData?.message?.toLowerCase() || ''
      
      const tokenErrorKeywords = [
        'token', 'expire', 'expired', 'unauthorized', 'authentication',
        'forbidden', 'invalid', 'session', '过期', '认证', '授权', 'jwt'
      ]
      
      // 检查错误消息或响应消息中是否包含token相关关键词
      return tokenErrorKeywords.some(keyword => 
        errorMessage.includes(keyword) || responseMessage.includes(keyword)
      )
    } else {
      // 401和403直接认为是token过期
      return true
    }
  }
  
  // 检查错误消息（兼容其他情况）
  const errorMessage = error.message?.toLowerCase() || ''
  const tokenErrorKeywords = [
    'token', 'expire', 'expired', 'unauthorized', 'authentication',
    'forbidden', 'invalid', 'session', '过期', '认证', '授权', 'jwt'
  ]
  
  if (tokenErrorKeywords.some(keyword => errorMessage.includes(keyword))) {
    return true
  }
  
  // 检查响应数据
  if (responseData) {
    const responseMessage = responseData.message?.toLowerCase() || ''
    if ((responseData.code === 500 || responseData.code === 401 || responseData.code === 403) && 
        tokenErrorKeywords.some(keyword => responseMessage.includes(keyword))) {
      return true
    }
  }
  
  return false
}

// 通用的API请求错误处理器
export const handleApiError = (error, responseData = null) => {
  console.error('API Error:', error)
  
  // 检查是否是token过期错误
  if (isTokenExpiredError(error, responseData)) {
    handleTokenExpired()
    throw new Error('Authentication expired. Please login again.')
  }
  
  // 其他错误处理
  if (error.message?.includes('timeout')) {
    throw new Error('Request timeout. Please check your network connection and try again.')
  } else if (error.message?.includes('Connection refused') || error.message?.includes('fetch')) {
    throw new Error('Backend service is unavailable. Please try again later or contact support.')
  } else {
    throw error
  }
}

// 获取当前用户信息
export const getCurrentUser = () => {
  try {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  } catch (error) {
    console.error('Failed to parse user info:', error)
    return null
  }
}

// 检查用户是否已登录
export const isAuthenticated = () => {
  const userInfo = getCurrentUser()
  const token = localStorage.getItem('userToken')
  return !!(userInfo && token)
}